export default __webpack_public_path__ + "static/media/SIW400H_T015_30_W10.d33fcee8.webp";